import { PayloadAction } from '../../../store.model';
import { Sort, SortOrder } from '../../grid';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../search.action';
import { SearchState } from '../search.state';

import { SortRows } from './sort-rows.action';

export function sortRowsReducer(
    state: SearchState,
    action: PayloadAction<ActionType.EVAL_SEARCH__SORT_ROWS, SortRows>,
): SearchState {
    try {
        const currentSortState: Sort = state.sortOptions ?? {
            columnId: null,
            order: null,
        };
        let nextSortOrder = action.payload.options?.order;
        if (currentSortState.columnId === action.payload.options?.columnId) {
            nextSortOrder =
                currentSortState.order === SortOrder.ASC
                    ? SortOrder.DESC
                    : SortOrder.ASC;
        }
        const nextSortOptions: Sort = {
            ...currentSortState,
            columnId: action.payload.options?.columnId,
            order: nextSortOrder,
        };

        const nextFilteredRows = sortRows(state.filteredRows, nextSortOptions);

        return {
            ...state,
            sortOptions: nextSortOptions,
            filteredRows: nextFilteredRows,
        };
    } catch {
        return {
            ...state,
        };
    }
}
